import componentHelper from '../../modules/component_helper.js';

angular.module('vastdesk').
  component('postalCodeInput',  {
    bindings: {
      formName: '@',
      formId: '@',
      selectedOptions: '<',
      dspSub: '<',
    },
    template: require("../templates/postalCodeInput.html"),
    controllerAs: '$postalCodeInputCtrl',
    controller: [function() {
      this.$onInit = function() {
        this.placeholder = this.dspSub ? "10001, SW1A, 75001, B1228" : "10001, GB:SW1A, FR:75001, AR:B1228";
      };
    }]
});
